export const initialStore = {
  fullName: { name: '', lastName: '' },
  streetAddress: '',
  postalCode: '',
  country: '',
  title: '',
  businessCategories:"",
  currentCompany: '',
  city: '',
  state: '',
  requiredFields: [],
  queryStore: '',
  sourceURLs: '',
  page: 1,
  firstRender: true,
  downloadData: {
    downloadQueryStore: '',
    download_id: ''
  },
  recordRecency: {
    dateAdded: '',
    dateUpdated: ''
  },
  // R33: New filters for property ownership
  mostRecentPropertyPurchaseDate: {
    startDate: '',
    endDate: ''
  },
  propertiesOwnedDatePurchased: {
    startDate: '',
    endDate: ''
  },
  propertiesOwnedDateSold: {
    startDate: '',
    endDate: '',
    includeNotSold: false
  },
  orFields: [],
  dataResults: [], // State to hold the data results
  isQueryLoading: false,
}
